import { defineAsyncComponent, h } from 'vue'

const aliases = {}

const hdx = {
  component: props => {
    const { icon, ...rest } = props
    return h(props.tag, rest, [
      h(
        defineAsyncComponent(() => import(`./hdx/hd-icon-${icon}.vue`)),
        { class: 'v-icon__svg' }
      )
    ])
  }
}

export { aliases, hdx }
